import ApiBase from "./ApiBase";

export default class ApiLayersMap {
    static async ListAll(successCallback, errorCallback) {
        let url = ApiBase.MakeUrl("WebService/LayersMap/ListAll");
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                })
            });
            const json = await response.json();
            if (json.success) {
                successCallback(json);
            }
            else {
                errorCallback(json);
            }

        } catch (error) {
            console.log("error:", error);
        }
    }  
    
    static async ListLayerInfo(conditions, successCallback, errorCallback) {
        let url = ApiBase.MakeUrl("WebService/LayersMap/ListLayerInfo");
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                }),
                body: JSON.stringify(conditions)
            });
            const json = await response.json();
            if (json.success) {
                successCallback(json);
            }
            else {
                errorCallback(json);
            }

        } catch (error) {
            console.log("error:", error);
        }
    }
}
